import { useAtom } from "jotai";

import { noticeboardDataVar } from "@/variables/globalVar";

export function useNoticeboardData() {
  const [noticeboardData, setNoticeboardDataVar] = useAtom(noticeboardDataVar);

  return { noticeboardData, setNoticeboardDataVar };
}
